import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';

import { ModalService } from '../../../services/modal.service';

@Component({
  selector: 'app-discard-changes-modal',
  templateUrl: './discard-changes-modal.component.html',
  styleUrl: './discard-changes-modal.component.scss',
})
export class DiscardChangesModalComponent implements AfterViewInit {
  @ViewChild('focus') focus: ElementRef<HTMLButtonElement>;

  @Input() header: string;
  @Input() message: string;

  constructor(private modalService: ModalService) {}

  ngAfterViewInit(): void {
    this.focus.nativeElement.focus();
  }

  onYes() {
    this.modalService.close(true);
  }

  onNo() {
    this.modalService.close(false);
  }

  back() {
    this.modalService.dismiss();
  }
}
